import { CertificateValidationResults } from 'App/types';
import {
  RESET_DFSP_CA,
  SET_DFSP_CA_ERROR,
  ResetDFPCAAction,
  SetDFSPCAErrorAction,
  SET_DFSP_CA_ROOT_CERTIFICATE,
  SET_DFSP_CA_INTERMEDIATE_CHAIN,
  SET_DFSP_CA_VALIDATIONS,
  SET_DFSP_CA_VALIDATION_STATE,
  CHANGE_DFSP_CA_ROOT_CERTIFICATE,
  CHANGE_DFSP_CA_INTERMEDIATE_CHAIN,
  SHOW_DFSP_CA_ROOT_CERTIFICATE_MODAL,
  HIDE_DFSP_CA_ROOT_CERTIFICATE_MODAL,
  SHOW_DFSP_CA_INTERMEDIATE_CHAIN_MODAL,
  HIDE_DFSP_CA_INTERMEDIATE_CHAIN_MODAL,
  SetDFSPCARootCertificateAction,
  SetDFSPCAIntermediateChainAction,
  SetDFSPCAValidationsAction,
  SetDFSPCAValidationsStateAction,
  ChangeDFSPCARootCertificateAction,
  ChangeDFSPCARootIntermediateChainAction,
  ShowDFSPCARootCertificateModalAction,
  HideDFSPCARootCertificateModalAction,
  ShowDFSPCAIntermediateChainModalAction,
  HideDFSPCAIntermediateChainModalAction,
  DownloadDFSPCARootCertificateAction,
  DOWNLOAD_DFSP_CA_ROOT_CERTIFICATE,
  DownloadDFSPCAIntermediateChainAction,
  DOWNLOAD_DFSP_CA_INTERMEDIATE_CHAIN,
  ChangeAndSubmitDFSPCARootCertificateAction,
  CHANGE_AND_SUBMIT_DFSP_CA_ROOT_CERTIFICATE,
  ChangeAndSubmitDFSPCARootIntermediateChainAction,
  CHANGE_AND_SUBMIT_DFSP_CA_INTERMEDIATE_CHAIN,
  SET_AUTO_GENERATE_DFSP_CA_CERTIFICATE,
  AutoGenerateDFSPCACertificateAction,
  ShowDFSPCAHubCertificateModalAction,
  SHOW_DFSP_CA_HUB_CERTIFICATE_MODAL,
  HideDFSPCAHubCertificateModalAction,
  HIDE_DFSP_CA_HUB_CERTIFICATE_MODAL,
  DownloadDFSPCAHubCertificateAction,
  DOWNLOAD_DFSP_CA_HUB_CERTIFICATE,
  SET_DFSP_CA_HUB_CERTIFICATE,
  SetDFSPCAHubCertificateAction,
  SET_DFSP_CA_HUB_CERTIFICATE_ERROR,
  SetDFSPCAHubCertificateErrorAction,
  RequestDFSPCAHubCertificateModalAction,
  REQUEST_DFSP_CA_HUB_CERTIFICATE,
  RequestDFPCAAction,
  REQUEST_DFSP_CA,
} from './types';

export function resetDFPCA(): ResetDFPCAAction {
  return {
    type: RESET_DFSP_CA,
  };
}

export function setDFSPCAError({ error }: { error: string }): SetDFSPCAErrorAction {
  return {
    type: SET_DFSP_CA_ERROR,
    error,
  };
}

export function requestDFPCA(): RequestDFPCAAction {
  return {
    type: REQUEST_DFSP_CA,
  };
}

export function setDFSPCARootCertificate({
  certificate,
}: {
  certificate: string;
}): SetDFSPCARootCertificateAction {
  return {
    type: SET_DFSP_CA_ROOT_CERTIFICATE,
    certificate,
  };
}

export function setDFSPCAIntermediateChain({
  certificate,
}: {
  certificate: string;
}): SetDFSPCAIntermediateChainAction {
  return {
    type: SET_DFSP_CA_INTERMEDIATE_CHAIN,
    certificate,
  };
}

export function setDFSPCAValidations({
  validations,
}: {
  validations: CertificateValidationResults[];
}): SetDFSPCAValidationsAction {
  return {
    type: SET_DFSP_CA_VALIDATIONS,
    validations,
  };
}

export function setDFSPCAValidationsState({
  validationState,
}: {
  validationState: string | undefined;
}): SetDFSPCAValidationsStateAction {
  return {
    type: SET_DFSP_CA_VALIDATION_STATE,
    validationState,
  };
}

export function changeDFSPCARootCertificate({
  certificate,
}: {
  certificate: string;
}): ChangeDFSPCARootCertificateAction {
  return {
    type: CHANGE_DFSP_CA_ROOT_CERTIFICATE,
    certificate,
  };
}

export function changeDFSPCARootIntermediateChain({
  certificate,
}: {
  certificate: string;
}): ChangeDFSPCARootIntermediateChainAction {
  return {
    type: CHANGE_DFSP_CA_INTERMEDIATE_CHAIN,
    certificate,
  };
}

export function showDFSPCARootCertificateModal(): ShowDFSPCARootCertificateModalAction {
  return {
    type: SHOW_DFSP_CA_ROOT_CERTIFICATE_MODAL,
  };
}

export function hideDFSPCARootCertificateModal(): HideDFSPCARootCertificateModalAction {
  return {
    type: HIDE_DFSP_CA_ROOT_CERTIFICATE_MODAL,
  };
}

export function downloadDfspCaRootCertificate(): DownloadDFSPCARootCertificateAction {
  return {
    type: DOWNLOAD_DFSP_CA_ROOT_CERTIFICATE,
  };
}

export function showDFSPCAIntermediateChainModal(): ShowDFSPCAIntermediateChainModalAction {
  return {
    type: SHOW_DFSP_CA_INTERMEDIATE_CHAIN_MODAL,
  };
}

export function hideDFSPCAIntermediateChainModal(): HideDFSPCAIntermediateChainModalAction {
  return {
    type: HIDE_DFSP_CA_INTERMEDIATE_CHAIN_MODAL,
  };
}

export function downloadDfspCaIntermediateChain(): DownloadDFSPCAIntermediateChainAction {
  return {
    type: DOWNLOAD_DFSP_CA_INTERMEDIATE_CHAIN,
  };
}

export function changeAndSubmitDFSPCARootCertificate({
  certificate,
}: {
  certificate: string;
}): ChangeAndSubmitDFSPCARootCertificateAction {
  return {
    type: CHANGE_AND_SUBMIT_DFSP_CA_ROOT_CERTIFICATE,
    certificate,
  };
}

export function changeAndSubmitDFSPCARootIntermediateChain({
  certificate,
}: {
  certificate: string;
}): ChangeAndSubmitDFSPCARootIntermediateChainAction {
  return {
    type: CHANGE_AND_SUBMIT_DFSP_CA_INTERMEDIATE_CHAIN,
    certificate,
  };
}

export function autoGenerateDFSPCACertificate({
  certificate,
}: {
  certificate: string;
}): AutoGenerateDFSPCACertificateAction {
  return {
    type: SET_AUTO_GENERATE_DFSP_CA_CERTIFICATE,
    certificate,
  };
}

export function requestDFSPCAHubCertificate(): RequestDFSPCAHubCertificateModalAction {
  return {
    type: REQUEST_DFSP_CA_HUB_CERTIFICATE,
  };
}

export function setDFSPCAHubCertificate({
  certificate,
}: {
  certificate: string;
}): SetDFSPCAHubCertificateAction {
  return {
    type: SET_DFSP_CA_HUB_CERTIFICATE,
    certificate,
  };
}

export function setDFSPCAHubCertificateError({
  error,
}: {
  error: string;
}): SetDFSPCAHubCertificateErrorAction {
  return {
    type: SET_DFSP_CA_HUB_CERTIFICATE_ERROR,
    error,
  };
}

export function showDFSPCAHubCertificateModal(): ShowDFSPCAHubCertificateModalAction {
  return {
    type: SHOW_DFSP_CA_HUB_CERTIFICATE_MODAL,
  };
}

export function hideDFSPCAHubCertificateModal(): HideDFSPCAHubCertificateModalAction {
  return {
    type: HIDE_DFSP_CA_HUB_CERTIFICATE_MODAL,
  };
}

export function downloadDfspCaHubCertificate(): DownloadDFSPCAHubCertificateAction {
  return {
    type: DOWNLOAD_DFSP_CA_HUB_CERTIFICATE,
  };
}
